import React from "react";
import { Outlet } from "react-router-dom";

import DashboardLayout from "./DashboardLayout";

const DashboardRouteLayout = () => (
  <DashboardLayout>
    <Outlet />
  </DashboardLayout>
);

export default DashboardRouteLayout;
